import type { Paginate, SearchResponse_for_IndexedDebtor } from "$apis/parkito";

export type Data = {
  page: number;
  pageSize: number;
  pageCount?: number;
  noPages?: number;
  totalCount?: number;
};

export const defaultData = (): Data => {
  return {
    page: 1,
    pageSize: 50,
  };
};

export const dataFromPaginated = (
  res: PaginatedResult<any> | SearchResponse_for_IndexedDebtor,
): Data => {
  return {
    page: res.page,
    pageSize: res.pageSize,
    noPages: res.pageCount,
    totalCount: res.totalCount,
  };
};

export interface PaginatedResult<T> {
  page: number;
  pageSize: number;
  pageCount: number;
  totalCount: number;
  items: Array<T>;
}
